import { HttpInterceptorFn } from '@angular/common/http'
import { inject } from '@angular/core'
import { AuthService } from '@services/auth.service'
import { PcaApiService } from '@services/api/pca-api-base.service'
import { isApiUrl } from '@utils/api-origin.util'

/**
 * `Authorization` só para as APIs da SilGov (lista branca, spec 048). Antes o token ia a todo host chamado pelo
 * `HttpClient`, menos os listados: o POST direto ao bucket do visitante, o viacep e qualquer host novo o recebiam.
 */
export const JwtInterceptor: HttpInterceptorFn = (request, next) => {
    const authService = inject(AuthService)
    const token = authService.token
    const signin = request.url.includes('signin')
    const refresh = request.url.includes('/v2/refresh')

    if (signin || refresh || !isApiUrl(request.url)) {
        return next(request)
    }

    if (token) {
        const headers = PcaApiService.updateHeaders(request, { authorization: `Bearer ${token}` })
        return next(request.clone({ headers }))
    }

    return next(request)
}
